module.exports = __webpack_public_path__ + "img/wix_1.530f4cc8.png";